import { render, staticRenderFns } from "./exchange-form.pug?vue&type=template&id=0aabc2a0&scoped=true&lang=pug&external"
import script from "./exchange-form.js?vue&type=script&lang=js&external"
export * from "./exchange-form.js?vue&type=script&lang=js&external"
import style0 from "./exchange-form.scss?vue&type=style&index=0&id=0aabc2a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabc2a0",
  null
  
)

export default component.exports